// databaseNode.js

import { BaseNode } from './BaseNode';
import { Position } from 'reactflow';

export const DatabaseNode = ({ id, data }) => {
  const handles = [
    {
      type: 'target',
      position: Position.Left,
      id: `${id}-query`,
      style: { left: '-2px' }
    },
    {
      type: 'source',
      position: Position.Right,
      id: `${id}-data`,
      style: { right: '-2px' }
    }
  ];

  const fields = [
    {
      name: 'connection',
      label: 'Connection',
      type: 'text',
      defaultValue: data?.connection || 'postgresql://localhost:5432/db'
    },
    {
      name: 'table',
      label: 'Table',
      type: 'text',
      defaultValue: data?.table || 'users'
    },
    {
      name: 'operation',
      label: 'Operation',
      type: 'select',
      defaultValue: data?.operation || 'select',
      options: [
        { value: 'select', label: 'SELECT' },
        { value: 'insert', label: 'INSERT' },
        { value: 'update', label: 'UPDATE' },
        { value: 'delete', label: 'DELETE' }
      ]
    }
  ];

  return (
    <BaseNode
      id={id}
      data={data}
      type="database"
      title="Database"
      handles={handles}
      fields={fields}
      className="max-w-[300px]"
    />
  );
};
